import React from 'react'
import './secondsection.scss';

const Secondsection = () => {
  return (
    <div className='secondiv'>
      <p>neoG Camp is a bootcamp that revives the learning for  <b>new</b>(neo) <b>generation</b> (+G) programmers.</p>
      <h3>What is “new” in our approach?</h3>
      <p>You know that the “science” part of computer science engineering has become about mugging up Data Structures and Algorithms and tutorial hell. We aim to bring back the <b>joy of creating,</b>  the engineering part.</p>

      <h3>Do more, create more, learn while doing.</h3>
      <p>Do all of this action-based industry-level learning with a closed focused peer group. Make creation your certificate and your skills your powers. Start with levelZero if you are a beginner and become an advanced programmer by joining levelOne.</p>

      <h3>Is it for you?</h3>
      <p>Yes. You can be a beginner, intermediate, from any background or stream, 15 years or 40 years old, want a job-switch, or excel in an existing job or just want to enhance your dev knowledge in best possible way.
        If you want to learn coding from a <b>structured cohort-based course.</b>  You must join.</p>

        <h3>Do we get you job?</h3>
      <p>This course will definitely help you upskill so that you have a good proof of work. We are <b>Not a Job Guarantee </b> program.</p>
    </div>
  )
}

export default Secondsection